<template lang="pug">
	.projects-global-search#global-search(v-if="showed" @click="handleClick($event)")
		.card
			.card-body
				.filters
					.horizontal-part.sp-between.font-16
						.horizontal-part.gap-5.pointer-cursor(v-b-tooltip.hover="{title: 'Search in projects names', container: '#global-search'}" @click="updateFilters('projects')")
							i.fa.fa-check-square(v-if="filters.projects")
							i.fa.fa-square(v-else)
							span(:class="{'invalid': !filters.projects && !filters.versions}") Projects
						.horizontal-part.gap-5.pointer-cursor(v-b-tooltip.hover="{title: 'Search in versions names', container: '#global-search'}" @click="updateFilters('versions')")
							i.fa.fa-check-square(v-if="filters.versions")
							i.fa.fa-square(v-else)
							span(:class="{'invalid': !filters.projects && !filters.versions}") Versions
						.workspace-select
							button(ref="customSelectButton" v-pseudo-modal-show="'workspace-picker-dropdown'" :class="{'invalid': !workspaces || !workspaces.filter(workspace => workspace.checked).length}")
								span {{workspacePickerTitle}}
								i.fa.fa-caret-down
							.workspace-picker(v-pseudo-modal="'workspace-picker-dropdown'" ref="picker")
								.form-check(v-for="workspace in workspaces")
									input(type="checkbox" checked="workspace.checked" value= "" :id="`workspace-checkmark-${workspace.codename}`" @input="checkWorkspace(workspace, $event.target.checked)")
									label(:for="`workspace-checkmark-${workspace.codename}`") {{workspace.title}}
				.results
					i.fa.fa-spinner.fa-spin(v-if="errorMessage && errorMessage === 'fetching'" :style="{'align-self': 'center', 'margin': 'auto', 'font-size': '60px'}")
					span.error-message(v-else-if="errorMessage && errorMessage.length") {{errorMessage}}
					.result(v-else v-for="version in versions" @click="openVersion(version)")
						.left-part
							.project-icon(:style="getProjectIconStyles(version.project)")
						.right-part
							span {{version.codename || version.title}}
							span(v-if="version.project" :style="{'font-weight': 'bold'}") {{version.project.title || version.project.codename || ''}}
</template>

<script>

import Screen 				from '../../mixins/screen';

import { Project } 			from '../../services/Project';
import { Version } 			from '../../services/Version';
import { Settings } 		from '../../services/Settings';
import {Layout} from "@/services/Layout";

export default {
	name: "ProjectsGlobalSearch",
	mixins: [Screen],
	props: ['parent', 'searchValue'],
	screen: {
		updateOn: [],
		events: {
			'Global Search Results': function(results) {
				this.versions = results;
				if (results && results.length) this.errorMessage = '';
				else this.errorMessage = 'No results found';
			},
			'Pseudo Modal Process Hide': function (names) {
			}
		}
	},
	watch: {
		searchValue() {
			if (this.checkFilters()) this.search();
		},
		showed(showed) {
			if (!showed) return;
			this.$nextTick(() => {
				let picker = this.$refs.picker;
				let button = this.$refs.customSelectButton;
				if (picker && button) {
					picker.style.display = 'block';
					button.style.width = picker.getBoundingClientRect().width + 'px';
					picker.style.top = button.offsetTop + button.offsetHeight + 'px';
					picker.style.left = button.offsetLeft + 'px';
					picker.style.display = 'none';
				}
			})
		}
	},
	data() {

		this.Project = Project;
		this.Version = Version;
		this.Settings = Settings

		return {
			workspaces: [],
			title: '',
			versions: [],
			workspacePickerTitle: 'Workspace',
			errorMessage: '',
			filters: {
				projects: true,
				versions: true
			}
		}
	},
	mounted() {
		this.parentNode = document.querySelector(this.parent);

		this.errorMessage = 'Please enter your search filter';

		this.versions = [];

		this.workspaces = _.clone(Metadata.Workspaces);

		this.workspaces.forEach(workspace => {
			workspace.checked = true;
		});

		this.workspacePickerTitle = this.workspaces.length + (this.workspaces.length === 1 ? ' Workspace' : ' Workspaces');
		this.filters.projects = true;
		this.filters.versions = true;

		document.addEventListener('click', event => {
			if (!this.showed) return;
			if (!this.parentNode.contains(event.target)) {
				this.parentNode.classList.remove('focused');
				this.hide();
			} else {
				this.parentNode.querySelector('input').focus();
			}
		});

	},
	methods: {
		collectData() {

			this.parentNode.classList.add('focused');

			if (!this.versions || !this.versions.length) {
				if (this.checkFilters()) this.search();
			}

		},
		handleClick(event) {
			if (event.target && event.target.classList.contains('projects-global-search')) this.hide();
		},
		getProjectIconStyles(project) {

			if (!project) return;

			if (project.type === 'playable') {

				if (project.templateProps) {

					return {
						backgroundImage: `url(/Images/Icons/Playables/${project.templateProps.codename.replace(':', '-')}.png` + (Project.ProjectsIconsTimes[project.id] ? '?v=' + Project.ProjectsIconsTimes[project.id] : '') + ')'
					};

				} else {

					return {
						backgroundImage: `url(/Images/Icons/Projects/${project.codename}.png` + (Project.ProjectsIconsTimes[project.id] ? '?v=' + Project.ProjectsIconsTimes[project.id] : '') + ')'
					};

				}

			} else if (project.type === 'banner') {

				if (project.templateProps) {
					return {
						backgroundImage: `url(/Images/Icons/Banners/${project.templateProps.codename}.png)`
					};
				}

			} else if (project.type === 'end-card') {

				if (project.templateProps) {
					return {
						backgroundImage: `url(/Images/Icons/EndCards/${project.templateProps.codename}.png)`
					};
				}

			}

		},
		checkWorkspace(workspace, value) {
			workspace.checked = value;
			let checkedWorkspaces = this.workspaces.filter(workspace => workspace.checked);
			this.workspacePickerTitle = checkedWorkspaces.length + (checkedWorkspaces.length === 1 ? ' Workspace' : ' Workspaces');
			if (this.checkFilters()) this.search();
		},
		openVersion(version) {
			this.hide();
			let workspace = this.workspaces.find(workspace => version.project.Tags[`workspace-${workspace.codename}`]);

			let versionToUpdate = _.clone(version);
			delete versionToUpdate.project;

			Publisher.selectPublisher(version.publisher_id);

			Layout.setLayoutWorkspace(workspace.codename);

			Layout.setPage(version.project.type + 's');

			Project.setProject(parseInt(version.project.id), version.project);
			Project.selectProject(parseInt(version.project.id));

			Version.updateVersion(version);
			Version.selectVersion(version.id);

		},
		search() {
			if (this.searchTimeout) clearTimeout(this.searchTimeout);
			this.errorMessage = 'fetching';

			this.searchTimeout = setTimeout(() => {
				Server.sendToSocket({
					GlobalSearch: {
						filters: {
							projects: this.filters.projects,
							versions: this.filters.versions,
							workspaces: this.workspaces.filter(workspace => workspace.checked).map(workspace => workspace.codename)
						},
						value: this.searchValue
					}
				});
			}, 350);

		},

		updateFilters(property) {
			this.filters[property] = !this.filters[property];
			if (this.checkFilters()) this.search();
		},

		checkFilters() {
			if (!this.searchValue || !this.searchValue.length) {
				this.errorMessage = 'Please enter your search filter';
				return false;
			}
			if (this.searchValue.trim().length < 2) {
				this.errorMessage = 'Please enter at least 2 characters in search filter';
				return false;
			}
			if (!this.workspaces.filter(workspace => workspace.checked).length) {
				this.errorMessage = 'Please select at least one workspace';
				return false;
			}
			if (!this.filters.projects && !this.filters.versions) {
				this.errorMessage = 'Filters must include projects or versions';
				return false;
			}
			this.errorMessage = '';
			return true;
		}
	}
}
</script>


<style lang="sass">

.projects-global-search
	display: flex
	position: absolute
	z-index: 2000
	transform: translate(-32px, 7px)
	line-height: 21px
	font-size: 14px
	text-align: left

	>.card
		width: 350px
		margin: auto
		display: flex
		height: 400px
		box-shadow: 0 0 20px rgba(0, 0, 0, 0.8)
		overflow: hidden
		transition: height 0.5s
		will-change: height
		border-radius: 0.5rem

		>.card-body
			display: flex
			flex-direction: column
			overflow: hidden
			height: 100%
			padding: 15px

		.filters
			display: flex
			flex-direction: column
			gap: 10px
			border-bottom: 1px solid #24282c
			padding-bottom: 10px
			line-height: 25px

			>.search-wrapper
				display: flex
				flex-direction: row
				font-size: 16px
				gap: 10px

				>i
					margin: auto

				>input
					width: 100%

			.horizontal-part
				display: flex
				flex-direction: row
				align-items: center

				span.invalid
					color: red

				&.sp-between
					justify-content: space-between
				&.gap-5
					gap: 5px
				&.font-16
					font-size: 16px
				&.pointer-cursor
					cursor: pointer
					user-select: none

			.workspace-select
				>button
					background: #343b41
					border: 1px solid #23282c
					color: #fff
					padding: 5px 10px
					display: flex
					justify-content: space-between
					align-items: center
					border-radius: 0.25rem

					&.invalid
						color: red

					&:focus
						border-color: #8ad4ee
						outline: 0
						box-shadow: 0 0 0 0.2rem rgba(32,168,216,.25)

				.workspace-picker
					position: absolute
					background: #343b41
					padding: 5px 0
					border-radius: 0.25rem
					border: 1px solid #23282c
					border-top: unset

					>.form-check
						padding: 0 10px
						display: flex
						align-items: center
						cursor: pointer
						gap: 5px
						&:hover
							background-color: #515b65

						>input,>label
							cursor: pointer
							margin: unset

		.results
			overflow: hidden auto
			margin-top: 10px
			display: flex
			flex-direction: column
			gap: 10px
			height: 100%

			>.result
				display: flex
				flex-direction: row
				gap: 20px
				cursor: pointer
				border-radius: 10px

				&:hover
					background-color: #2f363c

				>.right-part
					display: flex
					flex-direction: column
					justify-content: space-between
					padding: 3px 0

			.project-icon
				width: 50px
				height: 50px
				background: 50%/100% no-repeat
				border-radius: 10px

			&::-webkit-scrollbar
				width: 10px

			&::-webkit-scrollbar-thumb
				background: #24282c
				border-radius: 5px


</style>

